import React, { useState } from 'react'
import uploadPic from "../../assets/images/profile/image.png";
import { Form } from "react-bootstrap";
import InstituteHeader from '../../components/header/InstituteHeader';
import { Link } from 'react-router-dom';
import Flatpickr from "react-flatpickr";
import InstituteMobileHeader from '../../components/header/InstituteMobileHeader';

const InstituteProfile = () => {
    const [isShowMobile, setShowMobile] = useState(false);
    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };
    return (
        <>
            <InstituteMobileHeader handleMobile={handleMobile} />
            <InstituteHeader clname="dashboardheader" handleMobile={handleMobile} />
            <div className="container">
                <div className="edit-profile-main-container p-4">
                    <div className="profile-resume-heading-cont d-flex align-items-center p-4">
                    </div>
                    <div className="edit-profile-upload d-flex justify-content-between align-items-center">
                        <div className=" edit-profile-pic-cont d-flex align-items-center">
                            <div className="edit-profile-pic-main d-flex justify-content-center align-items-center me-3">
                                <div className="edit-proifle-pic">
                                    <img src={uploadPic} alt="" srcset=""></img>
                                </div>
                            </div>

                            <div className="edit-profile-pic-selection-cont">
                                <h3 className="f-14 f-600 mb-2">Upload a new avatar:</h3>
                                <h6 className="f-12 f-500 mb-2">JPG 80x80px</h6>
                                <input type="file" />
                            </div>
                        </div>

                        <div className="edit-profile-save-file">
                            <div className="khojPrimaryBtn1 ms-3" >
                                <Link to="/" className="">Save Profile</Link>
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div className="edit-profile-information-cont">
                        <div className="edit-profile-information-heading">Information</div>

                        <div className="row">
                            <div className="col-md-6 mt-2">
                                <label htmlFor="about" className="f-14 f-700">
                                    Institution Name{" "}
                                </label>
                                <input
                                    type="text"
                                    style={{ width: "100%" }}
                                // value={contactNo}
                                // onChange={(e) => setContactNo(e.target.value)}
                                />
                            </div>

                            <div className="col-md-6 mt-2">
                                <label htmlFor="about" className="f-14 f-700">
                                    Year Established
                                </label>
                                <Flatpickr
                                // data-enable-time
                                // value={date}
                                // onChange={([date]) => {
                                //     this.setState({ date });
                                // }}
                                />
                            </div>

                            <div className="col-md-6 mt-2">
                                <label htmlFor="about" className="f-14 f-700">
                                    Phone Number
                                </label>
                                <input
                                    type="number"
                                    style={{ width: "100%" }}
                                // value={contactNo}
                                // onChange={(e) => setContactNo(e.target.value)}
                                />
                            </div>

                            <div className="col-md-6 mt-2">
                                <label htmlFor="about" className="f-14 f-700">
                                    Email
                                </label>
                                <input
                                    type="email"
                                    style={{ width: "100%" }}
                                // value={contactNo}
                                // onChange={(e) => setContactNo(e.target.value)}
                                />
                            </div>

                            <div className="col-md-12 mt-2">
                                <label htmlFor="about" className="f-14 f-700">
                                    Address<span className="text-danger ms-2 cityData">*</span>
                                </label>
                                <textarea />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12  edit-profile-radio-cont">
                                <div className="edit-profile-show-profile f-14 f-700 d-block">Show my profile</div>

                                <div className="d-flex">
                                    <Form.Check
                                        type="radio"
                                        id="default-radio"
                                        label="Show"
                                        className="edit-profile-show-radio"
                                        name="visibility"
                                    />
                                    <Form.Check
                                        type="radio"
                                        id="default-radio" // Add a unique id for accessibility
                                        label="Hidden" // Add the text you want to display beside the radio button
                                        className="edit-profile-show-radio"
                                        name="visibility"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default InstituteProfile